import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  COLOR_OPTIONS,
  COLOR_BADGE_VARIANT_MAP,
  COLOR_BADGE_CLASSNAME_MAP,
  type ColorOption,
} from './entity-type-badge'

export interface ColorPickerProps {
  value: string | null | undefined
  onChange: (color: string) => void
  disabled?: boolean
}

export function ColorPicker({ value, onChange, disabled }: ColorPickerProps) {
  const currentColor: ColorOption = (COLOR_OPTIONS as readonly string[]).includes(value ?? '') ? value as ColorOption : 'default'

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-start gap-2"
          disabled={disabled}
          data-testid="btn-color-picker"
        >
          <Badge
            variant={COLOR_BADGE_VARIANT_MAP[currentColor]}
            className={COLOR_BADGE_CLASSNAME_MAP[currentColor]}
          >
            {currentColor}
          </Badge>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-48">
        {COLOR_OPTIONS.map((color) => (
          <DropdownMenuItem
            key={color}
            onClick={() => onChange(color)}
            className="gap-2"
            data-testid={`color-option-${color}`}
          >
            <Badge
              variant={COLOR_BADGE_VARIANT_MAP[color]}
              className={COLOR_BADGE_CLASSNAME_MAP[color]}
            >
              {color}
            </Badge>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
